/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import jsonExport from "jsonexport/dist";
import { fillDownRows } from "../../../utils/exportsUtils";

import { Card, Divider, useMediaQuery, Tab, Tabs } from "@material-ui/core";

import {
  CreateButton,
  Datagrid,
  downloadCSV,
  EditButton,
  FilterButton,
  ListContextProvider,
  ListToolbar,
  RefreshButton,
  SimpleList,
  TextField,
  Title,
  TopToolbar,
  useListContext,
} from "react-admin";

import { ChevronRightIcon } from "../../../components/common/iconography";
import { Empty } from "../../../components/common/Empty";
import ExportButton from "../../../components/common/ExportButton";
import { ForceTitle } from "../../../components/common/ForceTitle";
import { SearchField } from "../../../components/common/SearchField";
import { Pagination } from "../../../components/Pagination";
import { QuickFilter } from "../../../components/common/QuickFilter";
import { ColorField } from "../../../components/common/ColorField";

import { isSubscriptionDisabled, logError } from "../../../utils/appUtils";
import { useSearchableList } from "../../../dataProvider/useSearchableList";
import { AccountState, AccountStatus } from "../../../utils/constants";
import { fetchTriggerEnabled } from "../../../utils/zapierUtils";

import { ServicesPeak } from "../services/ServicesPeak";
import AccountSyncMenuButton from "./AccountSyncMenuButton";
import { AccountStatusIcon } from "./AccountStatusIcon";
import { AccountImportButton } from "./AccountImportButton";

const tabs = [
  {
    id: AccountStatus.ACTIVE,
    name: "Active",
    active: "true",
  },
  {
    id: AccountStatus.ARCHIVED,
    name: "Archived",
    active: "false",
  },
];

const exporter = (accounts) => {
  debugger;
  const accountsForExport = accounts.map((account) => {
    const accountForExport = { ...account };
    if (account.contacts?.length > 0) {
      accountForExport.billingContacts = account.contacts.map((itm) => {
        return {
          fullName: itm.name,
          email: itm.email,
          phone: itm.phone,
        };
      });
      delete accountForExport.contacts;
    }

    delete accountForExport.active;
    delete accountForExport.addressState;
    delete accountForExport.bolTemplate;
    delete accountForExport.createdAt;
    delete accountForExport.externalStatus;
    delete accountForExport.groups;
    delete accountForExport.history;
    delete accountForExport.inboundCustomFields;
    delete accountForExport.inventoryCustomFields;
    delete accountForExport.outboundCustomFields;
    delete accountForExport.owner;
    delete accountForExport.products;
    delete accountForExport.reloadYardId;
    delete accountForExport.services;
    delete accountForExport.status;
    delete accountForExport.type;
    delete accountForExport.updatedAt;
    debugger;

    return accountForExport;
  });

  jsonExport(fillDownRows(accountsForExport), { rename: ["accountId"] }, (err, csv) => {
    downloadCSV(csv, `accounts_${new Date().toLocaleDateString()}`); // download as 'accounts.csv` file
  });
};

const AccountSearchField = (props) => {
  const listContext = useListContext(props);
  const { displayedFilters, filterValues, setFilters } = listContext;
  const { label, alwaysOn } = props;

  const handleSearch = (value) => {
    debugger;
    if (value) {
      const nextFilterValues = { ...filterValues };
      delete nextFilterValues.or;
      setFilters(
        {
          ...nextFilterValues,
          or: [
            { businessName: { matchPhrasePrefix: `${value}` } },
            { displayName: { matchPhrasePrefix: `${value}` } },
            { lotNumberPrefix: { wildcard: `*${value}*` } },
            { addressState: { wildcard: `*${value}*` } },
          ],
        },
        displayedFilters,
      );
    } else {
      const nextFilterValues = { ...filterValues };
      delete nextFilterValues.or;
      setFilters(nextFilterValues, displayedFilters);
    }
  };

  return (
    <SearchField
      id="searchTerm"
      label={label}
      margin="dense"
      variant="outlined"
      alwaysOn={alwaysOn}
      handleSearch={handleSearch}
    />
  );
};

const getListFilters = (tabValue) => [
  <AccountSearchField label="Search" tabValue={tabValue} alwaysOn />,
  <QuickFilter
    source="overLimit"
    label="Over Credit Limit"
    defaultValue={{ eq: true }}
  />,
  <QuickFilter source="overDue" label="Over Due" defaultValue={{ eq: true }} />,
];

const ListActions = (props) => {
  const { xsDown } = props;
  const { resource, total } = useListContext();
  const [isSyncEnabled, setIsSyncEnabled] = useState(false);

  useEffect(() => {
    const checkTrigger = async () => {
      try {
        const triggerEnabled = await fetchTriggerEnabled("accountImported");
        setIsSyncEnabled(triggerEnabled);
      } catch (err) {
        logError("accounts:accountList:triggerEnabled", err);
        setIsSyncEnabled(false);
      }
    };
    checkTrigger();
  }, []);

  return !xsDown ? (
    <TopToolbar>
      <FilterButton />
      <CreateButton disabled={isSubscriptionDisabled()} />
      {isSyncEnabled ? (
        <AccountSyncMenuButton total={total} exporter={exporter} />
      ) : (
        <>
          <AccountImportButton resource={resource} />
          <ExportButton
            disabled={total === 0}
            resource={resource}
            exporter={exporter}
          />
        </>
      )}
      <RefreshButton />
    </TopToolbar>
  ) : null;
};

const getSessionTab = () => {
  const sessionTab = Number(sessionStorage.getItem(`AccountsTab`));
  if (sessionTab && tabs[sessionTab]) {
    return sessionTab;
  }
  return 0;
};

export const AccountList = (props) => {
  const [tabIndex, setTabIndex] = useState(getSessionTab());
  const [defaultFilter, setDefaultFilter] = useState({
    reloadYardId: window.appUser.reloadYardId,
    activeBusinessName: {
      beginsWith: {
        active: tabs[tabIndex].active,
      },
    },
  });
  const xsDown = useMediaQuery((theme) => theme.breakpoints.down("xs"));
  const [defaultSearchFilter, setDefaultSearchFilter] = useState({
    reloadYardId: { eq: window.appUser.reloadYardId },
    active: { eq: tabs[tabIndex].active },
  });

  const defaultSort = {
    field: `{"key":"accountByActiveByName", "search":"displayName"}`,
    order: "ASC",
  };

  // memorize perPage settings
  // see useEffect [listContext?.perPage]) below
  const sessionPerPage = localStorage.getItem(`${props.resource}_perPage`);
  const [defaultPerPage, setDefaultPerPage] = useState(
    sessionPerPage ? Number(sessionPerPage) : 10,
  );

  const listContext = useSearchableList({
    ...props,
    resource: "accounts",
    basePath: "/accounts",
    defaultTitle: "Accounts",
    defaultFilter: defaultFilter,
    defaultSearchFilter: defaultSearchFilter,
    defaultPerPage: defaultPerPage,
    defaultSort: defaultSort,
  });

  useEffect(() => {
    if (listContext?.perPage) {
      localStorage.setItem(`${props.resource}_perPage`, listContext.perPage);
      setDefaultPerPage(Number(listContext.perPage));
    }
  }, [listContext?.perPage]);

  useEffect(() => {
    if (listContext?.filter) {
      // reset list on automatic stale list reset
      // Extract the key query from defaultSort
      const fieldObj = JSON.parse(defaultSort.field);
      const keyToCheck = fieldObj.key;

      // Check for the key's presence in filter
      const hasKey = keyToCheck in listContext.filter;
      const hasFilterValues = Object.keys(listContext.filterValues).length > 0;
      if (hasKey && hasFilterValues) listContext.setFilters({});
    }
  }, [listContext?.filter]);

  const handleTabChange = (value) => {
    debugger;
    setTabIndex(value);
    setDefaultFilter({
      reloadYardId: window.appUser.reloadYardId,
      activeBusinessName: {
        beginsWith: { active: tabs[value].active },
      },
    });
    setDefaultSearchFilter({
      reloadYardId: { eq: window.appUser.reloadYardId },
      active: { eq: tabs[value].active },
    });
    listContext.setPage(1);
  };

  return (
    <ListContextProvider value={listContext}>
      <Title title={<ForceTitle title="Accounts" />} />
      <ListToolbar
        {...props}
        filters={getListFilters(tabIndex)}
        actions={<ListActions xsDown={xsDown} />}
      />
      <Card>
        <AccountsTabs
          {...props}
          {...listContext}
          tabValue={tabIndex}
          setTabValue={handleTabChange}
          xsDown={xsDown}
        />
        <Pagination {...listContext} />
      </Card>
    </ListContextProvider>
  );
};

const AccountsTabs = ({ tabValue, setTabValue, setPage, ...props }) => {
  const { xsDown } = props;

  const handleChange = (event, value) => {
    sessionStorage.setItem("AccountsTab", value);
    // setPage(1);
    setTabValue(value);
  };

  return (
    <>
      <Tabs
        value={tabValue}
        indicatorColor="primary"
        textColor="primary"
        onChange={handleChange}
      >
        {tabs.map(
          (itm, idx) =>
            (!xsDown || itm.showSmall) && (
              <Tab key={itm.id} label={itm.name} id={`account-${idx}`} />
            ),
        )}
      </Tabs>
      <Divider />
      {tabs.map(
        (itm) =>
          itm.id === tabs[tabValue].id && (
            <AccountGrid {...props} key={itm.id} tabValue={itm.id} />
          ),
      )}
    </>
  );
};

const getSecondaryText = (record) => {
  if (record.address?.city && record.address?.state)
    return `${record.address.city}, ${record.address.state}`;
  else return record.phone;
};

const AccountGrid = ({ xsDown, mdDown, tabValue, ...props }) => {
  const { ids, page } = useListContext();

  if (tabValue === AccountState.ACTIVE && ids.length === 0 && page === 1)
    return <Empty {...props} message="Create a new account" />;

  if (tabValue === AccountState.ARCHIVED && ids.length === 0)
    return (
      <div
        style={{
          textAlign: "center",
          padding: "10px",
          color: "gray",
        }}
      >
        No archived accounts found.
      </div>
    );

  return xsDown ? (
    <SimpleList
      primaryText={(record) => record.businessName}
      secondaryText={(record) => getSecondaryText(record)}
      tertiaryText={(record) => `${record.lotNumberPrefix}`}
      leftIcon={(record) => <AccountStatusIcon record={record} />}
      rightIcon={() => (
        <ChevronRightIcon
          fontSize="large"
          color="secondary"
          style={{ marginLeft: 40, marginTop: 10 }}
        />
      )}
      linkType="edit"
      ids={ids}
    />
  ) : mdDown ? (
    <Datagrid rowClick="edit" expand={<ServicesPeak />} ids={ids}>
      <AccountStatusIcon source="externalStatus" label=" " sortable={false} />
      <ColorField source="color" label="Color" />
      <TextField
        source="displayName"
        label="Account"
        sortable={true}
        sortBy={`{"key":"accountByActiveByName", "search":"displayName"}`}
      />
      <TextField
        source="lotNumberPrefix"
        label="Lot No. Prefix"
        sortable={true}
        orderBy="accountByLotPrefix"
      />
      <TextField source="addressState" label="State" sortable={true} />
    </Datagrid>
  ) : (
    <Datagrid rowClick="edit" expand={<ServicesPeak />} ids={ids}>
      <AccountStatusIcon source="externalStatus" label=" " sortable={false} />
      <ColorField source="color" label="Color" />
      <TextField source="displayName" label="Display Name" sortable={true} />
      <TextField
        source="businessName"
        label="Account"
        sortable={true}
        sortBy={`{"key":"accountByActiveByName", "search":"displayName"}`}
      />
      <TextField
        source="lotNumberPrefix"
        label="Lot No. Prefix"
        sortable={true}
        sortBy={`{"key":"accountByLotPrefix", "search":"lotNumberPrefix"}`}
      />

      <TextField
        source="email"
        label="Email"
        sortable={true}
        sortBy={`{"key":"accountByEmail", "search":"email"}`}
      />
      <TextField source="phone" label="Phone" sortable={false} />
      <TextField source="addressState" label="State" sortable={true} />
      <EditButton />
    </Datagrid>
  );
};
